<div
  class="dropdown-user"
  [ngClass]="isMiniProfileVisible ? 'mini-profile-active' : 'mini-profile-inactive'">
  <div class="dropdown-user-detail">
    <div
      class="dropdown-user-photo"
      *ngIf="user?.photo !== null; else noSelectedPhoto"
      [style]="profileImageStyle"></div>
    <ng-template #noSelectedPhoto>
      <div class="dropdown-user-icon">
        <em class="icon-account"></em>
      </div>
    </ng-template>
    <div class="dropdown-user-meta">
      <p class="font-semibold">
        {{user?.employee.firstName}} {{user?.employee.lastName}}
      </p>
      <p>{{user?.employee.email}}</p>
      <p class="text-xs">Version: {{version}}</p>
      <div class="dropdown-user-action-buttons flex flex-wrap">
        <button
          xm
          (click)="profileRoute()"
          class="xm-xs xm-secondary text-xs">
          View Profile
        </button>
        <a
          (click)="logout()">
          <button xm class="xm-xs xm-secondary text-xs">Log Out</button>
        </a>
      </div>
    </div>
  </div>
  <div class="dropdown-user-shortcuts">
    <div>
      <select
        [(ngModel)]="userPreferences.theme"
        (ngModelChange)="saveUserThemeDropdown($event)"
        class="custom-select">
        <option
          *ngFor="let theme of userThemes | keyvalue"
          [ngValue]="theme.value">
          {{theme.key}}
        </option>
      </select>
    </div>
    <div class="margin-top-8">
      <label class="margin-bottom-4">Units</label>
      <div>
        <select
          [(ngModel)]="userPreferences.otherPrefs?.measurements.distance"
          (ngModelChange)="saveUserDistanceDropdown($event)"
          class="custom-select">
          <option
            *ngFor="let distance of distanceOptions | keyvalue"
            [ngValue]="distance.value">
            {{distance.value}}
          </option>
        </select>
      </div>
    </div>
  </div>
  <app-dropdown-notifications
    *ngIf="notifications?.length"
    [notifications]="notifications">
  </app-dropdown-notifications>
</div>

<ng-template
  #logutOutContent
  let-modal>
  <div class="modal-body">
    <p>Logging Out</p>
    <xm-preloader></xm-preloader>
  </div>
</ng-template>

<div
  class="content-overlay"
  [ngClass]="isMiniProfileVisible ? 'content-overlay-active' : 'content-overlay-inactive'"
  (click)="resetNavItemDropdowns()">
</div>
